var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
    _vm.isModalOpen
      ? _c(
          "div",
          {
            staticClass:
              "w-screen h-screen fixed top-0 left-0 bg-primary-navy bg-opacity-80 z-chatbot-front md:px-3 flex justify-center items-center"
          },
          [
            _c("div", {
              staticClass: "absolute top-0 left-0 w-full h-full cursor-pointer",
              on: { click: _vm.closeModal }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "w-full max-w-[980px] max-h-full pt-16 pb-13 md:px-24 relative bg-white rounded-lg"
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "w-10 h-10 absolute top-3 right-3",
                    attrs: { type: "button" },
                    on: { click: _vm.closeModal }
                  },
                  [
                    _c("Sprite", {
                      attrs: { id: "icon-close", classes: "w-full h-full" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.hasPostVideoContent ||
                (_vm.hasPostVideoContent && !_vm.videoEnded)
                  ? _c("div", { staticClass: "md:aspect-w-16 md:aspect-h-9" }, [
                      _c("div", [
                        _c("div", {
                          ref: "modalVideo",
                          staticClass: "plyr w-full h-full",
                          attrs: {
                            "data-plyr-provider": _vm.videoProvider,
                            "data-plyr-embed-id": _vm.videoId
                          }
                        })
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasPostVideoContent && _vm.videoEnded
                  ? _c(
                      "div",
                      { staticClass: "px-4 md:px-12 lg:px-30 text-center" },
                      [
                        _vm._t("critter"),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-[2rem] leading-base font-bold text-heading mb-2"
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.postVideoHeading) +
                                "\n        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "u-body-lg text-heading mb-9" },
                          [_vm._v(_vm._s(_vm.postVideoContent))]
                        ),
                        _vm._v(" "),
                        _vm.postVideoCtas.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col lg:flex-row justify-center gap-y-3 lg:gap-y-0 lg:gap-x-3 mb-9"
                              },
                              _vm._l(_vm.postVideoCtas, function(ctaBlock) {
                                return _c("CtaButton", {
                                  key: ctaBlock.uid,
                                  staticClass:
                                    "justify-center lg:justify-start",
                                  attrs: {
                                    buttonType: ctaBlock.type,
                                    label: ctaBlock.label,
                                    url: ctaBlock.url,
                                    clickFunction: function(e) {
                                      return _vm.ctaClickHandler(
                                        e,
                                        ctaBlock.url
                                      )
                                    }
                                  }
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("CtaButton", {
                          attrs: {
                            buttonType: "third",
                            tag: "button",
                            label: "Replay video",
                            iconId: "icon-replay",
                            iconReversed: true,
                            clickFunction: _vm.replayVideo
                          }
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }